import { render, staticRenderFns } from "./common-details.vue?vue&type=template&id=2cc2c901"
import script from "./common-details.vue?vue&type=script&lang=js"
export * from "./common-details.vue?vue&type=script&lang=js"
import style0 from "./common-details.vue?vue&type=style&index=0&id=2cc2c901&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports